export default {
    EXPIRATION_DATE_WARNING: 'EXPIRATION_DATE_WARNING',
    NO_STOCK: 'NO_STOCK',
    NOT_ELIGIBLE: 'NOT_ELIGIBLE',
    NON_ACCUMULATIVE: 'NON_ACCUMULATIVE',
    TEMPORARY_UNAVAILABLE: 'TEMPORARY_UNAVAILABLE'
};
  